import {useDispatch, useSelector} from "react-redux";
import {setMiraculousRetinolSeriesResultDetail} from "../../../reducers/miraculous-retinol-series.reducer";
import InputComponent from "../../../components/input.component";
import React from "react";

const InputField = ({fieldList}) => {
    const dispatch = useDispatch()
    const {resultDetail, miraculousRetinolSeriesErrorMessage} = useSelector(state => state.miraculousRetinolSeriesReducer)

    const onChange = (key, value) => {
        dispatch(setMiraculousRetinolSeriesResultDetail({[key]: value}))
    }

    return (
        <div className={"row space-x-16"}>
            <div className={"col space-y-4 w-1/2"}>
                <InputComponent item={fieldList[0]} data={resultDetail?.[fieldList[0].key]} error={miraculousRetinolSeriesErrorMessage} onChange={onChange}/>
            </div>
            <div className={"col space-y-4 w-1/2"}>
                {fieldList[1].map((item, i) => (
                    <InputComponent key={i} item={item} data={resultDetail?.[item.key]} error={miraculousRetinolSeriesErrorMessage} onChangeInput={onChange} onChange={onChange}/>
                ))}
            </div>
        </div>
    )
}

export default InputField